module.exports = __webpack_public_path__ + "static/icons/icon-user-report-640c438ddfc25258de962e2a35adecc1.svg";